var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/StyleTag/StyleTag.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/StyleTag/StyleTag.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "svgSprite")) {
var t_4 = t_1.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
["style"], 
["classes", "tag", "link"], 
function (l_style, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("style", l_style);
frame.set("classes", Object.prototype.hasOwnProperty.call(kwargs, "classes") ? kwargs["classes"] : "");frame.set("tag", Object.prototype.hasOwnProperty.call(kwargs, "tag") ? kwargs["tag"] : "button");frame.set("link", Object.prototype.hasOwnProperty.call(kwargs, "link") ? kwargs["link"] : "");var t_6 = "";t_6 += "\n    <";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
t_6 += " class=\"StyleTag ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
t_6 += "\" data-id=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((l_style),"id"), env.opts.autoescape);
t_6 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "tag") == "a") {
t_6 += "href=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "link"), env.opts.autoescape);
t_6 += "\"";
;
}
t_6 += ">\n        <span class=\"StyleTag-title\">";
t_6 += runtime.suppressValue(runtime.memberLookup((l_style),"title"), env.opts.autoescape);
t_6 += "</span>\n        <span class=\"StyleTag-close\">";
t_6 += runtime.suppressValue((lineno = 5, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "svgSprite"), "svgSprite", context, ["style-close"])), env.opts.autoescape);
t_6 += "</span>\n    </";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
t_6 += ">\n";
;
frame = callerFrame;
return new runtime.SafeString(t_6);
});
context.addExport("StyleTag");
context.setVariable("StyleTag", macro_t_5);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "render") == true) {
output += "\n    ";
output += runtime.suppressValue((lineno = 10, colno = 15, runtime.callWrap(macro_t_5, "StyleTag", context, [runtime.contextOrFrameLookup(context, frame, "style")])), env.opts.autoescape);
output += "\n";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/StyleTag/StyleTag.jinja"] , dependencies)